import React from "react";
import PropTypes from "prop-types";
// import Center from "../../components/adm";
import Center from "../../components/adm/farm/farmFilterList"
import Layout from "../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const CentersPage = () => {
  // let { uuid } = useParams();
  return <Layout body={<Center />} />;
};

CentersPage.propTypes = {};

export default CentersPage;
